module.exports = __webpack_public_path__ + "static/media/white_texture_bg@3x.323de5ba.webp";